import { ReactNode } from "react";
import { Box, InputLabel } from "../../mui";

export const RichTextReader = (props: { label?: ReactNode; customStyles?: any, html: string | undefined }) => {
  
  return (
    <Box>
      {props.label && <InputLabel shrink={true}>{props.label}</InputLabel>}
      <Box
        sx={{
          ...props.customStyles,
          img: { maxWidth: "100% !important" },
          'table': { borderCollapse: "collapse" },
          'td': {
            border: '1px solid #ccc',
            padding: 1.2
          },
        }}
        dangerouslySetInnerHTML={{ __html: props.html! }}
      ></Box>
    </Box>
  );
};
